import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select } from 'antd'
import InfoTooltip from '../../../../../elements/InfoTooltip'
import { get, isEmpty } from 'lodash'
import React, { Component, Fragment } from 'react'
import { compose } from 'recompose'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import withSort from '../../../../../elements/HOC/withSort'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../../elements/HOC/withSubDropdown'
import Currency from '../../../../../elements/Select/Currency'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../../../elements/Select/Organistaions'
import withData from '../../../../../elements/Select/withData'
import withSelectFetch from '../../../../../elements/Select/withSelectFetch'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import { arrVal, dateVal, normalizeNull, sessionItemByKeys, strVal } from '../../../../../modules/Utils'

const { TextArea } = Input

const ReceiptType = compose(
  withSelectFetch({ dropdown: 'transactions', name: 'receipt' }),
  withSpinning,
  withSubDropdown({ name: 'type' }),
  withSort
)(CustomSelect)
const DebitType = compose(
  withSelectFetch({ dropdown: 'transactions', name: 'debit' }),
  withSpinning,
  withSubDropdown({ name: 'type' }),
  withSort
)(CustomSelect)

const TransactionType = compose(
  withSelectFetch({ dropdown: 'transactions', name: 'type' }),
  withSpinning,
  withSort
)(CustomSelect)

class ReceiptForm extends Component {
  state = {
    company: '',
    url: '',
    currency: undefined,
    BankSelectCmp: Select,
    CurrencySelect: Select,
  }

  async componentDidMount() {
    await this.onChangeCompany(strVal(this.props, 'transaction.company._id'))
    await this.onChangeBank(get(this.props, 'transaction.bank._id'))
  }

  onChangeCompany = (company) => {
    const url = `corporates/banks/?status=Active` + (isEmpty(company) ? '' : `&owner=${company}`)
    const BankSelectCmp = compose(
      withUrlFetch({
        name: 'banks',
        url: url,
        cache: true,
        forceFetch: true,
      }),
      withSpinning,
      withSort
    )(CustomSelect)
    this.props.form.resetFields(['bank._id', 'currency'])
    this.setState({ company, BankSelectCmp, url })
  }
  onChangeBank = (bank) => {
    let sessionID = `banks_${this.state.url}_dropdown`
    const currency = get(sessionItemByKeys(sessionID, bank, '_id', 'bank'), 'currency')
    const multiCurrency = arrVal(sessionItemByKeys(sessionID, bank, '_id', 'bank'), 'multiCurrency')
    this.setState({
      CurrencySelect: compose(
        withData({
          data: [currency, ...multiCurrency].map((c) => ({
            key: c,
            value: c,
          })),
        })
      )(CustomSelect),
    })
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { transaction } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14, offset: 1 },
      },
    }
    const { BankSelectCmp, CurrencySelect } = this.state

    const isOnBehalf = getFieldValue('receipt.type') === 'on-behalf-of-3rd-party'

    console.log(getFieldValue('receipt.type'))

    return (
      <Form layout={'horizontal'}>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Company'}>
              {getFieldDecorator('company._id', {
                initialValue: get(transaction, 'company._id'),
                rules: [{ required: true, message: 'Please Select a Company!' }],
              })(<OrganisationsSelect onChange={this.onChangeCompany} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Bank Account'}>
              {getFieldDecorator('bank._id', {
                initialValue: get(transaction, 'bank._id'),
                rules: [{ required: true, message: 'Please Select a Bank!' }],
              })(
                <BankSelectCmp
                  style={{ width: '100%' }}
                  keyAtr={'_id'}
                  valueAtr={'title'}
                  placeholder={'Bank Account'}
                  onChange={this.onChangeBank}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Transaction Date'}>
              {getFieldDecorator('date', {
                initialValue: dateVal(transaction, 'date'),
                rules: [{ required: true, message: 'Please Select a Date!' }],
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Type'}>
              {getFieldDecorator('type', {
                initialValue: get(transaction, 'type'),
                rules: [{ required: true, message: 'Please Select a Type!' }],
              })(<TransactionType />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Amount'}>
              {getFieldDecorator('amount', {
                initialValue: get(transaction, 'amount'),
                rules: [{ required: true, message: 'Please Select a Amount!' }],
              })(<Input type="number" style={{ width: '80%' }} placeholder={'Amount'} />)}
              {getFieldDecorator('currency', {
                initialValue: get(transaction, 'currency'),
                rules: [{ required: true, message: 'Please Select a Currency!' }],
              })(<CurrencySelect style={{ width: 50 }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Balance'}>
              {getFieldDecorator('balance', {
                normalize: normalizeNull,
                initialValue: get(transaction, 'balance'),
              })(<InputNumber style={{ width: '100%' }} placeholder={'Balance'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...formItemLayout}
              label={<InfoTooltip value={'Bank Fees'} title={'Related Bank fees if any within this transaction'} />}>
              {getFieldDecorator('bankFees', {
                normalize: normalizeNull,
                initialValue: get(transaction, 'bankFees'),
              })(<InputNumber style={{ width: '100%' }} placeholder={'Bank Fees'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Notes'}>
              {getFieldDecorator('notes', {
                normalize: normalizeNull,
                initialValue: get(transaction, 'notes'),
              })(<TextArea autosize={{ minRows: 2, maxRows: 6 }} placeholder={'Notes'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Transaction Ref'}>
              {getFieldDecorator('remittance.ref', {
                normalize: normalizeNull,
                initialValue: get(transaction, 'remittance.ref'),
              })(<Input placeholder={'Transaction Ref'} />)}
            </Form.Item>
          </Col>
          {this.props.form.getFieldValue('type') === 'debit' && (
            <Fragment>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Debit Type'}>
                  {getFieldDecorator('debit.type', {
                    initialValue: get(transaction, 'debit.type'),
                    rules: [{ required: true, message: 'Please Select a Debit Type!' }],
                  })(<DebitType placeholder={'Debit Type'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Payment Currency'}>
                  {getFieldDecorator('debit.currency', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'debit.currency'),
                  })(<Currency />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Payment Amount'}>
                  {getFieldDecorator('debit.amount', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'debit.amount'),
                  })(<InputNumber style={{ width: '100%' }} placeholder={'Payment Amount'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'For Benefit of'}>
                  {getFieldDecorator('debit.benefit', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'debit.benefit'),
                  })(<Input placeholder={'For Benefit of'} />)}
                </Form.Item>
              </Col>
            </Fragment>
          )}
          {this.props.form.getFieldValue('type') === 'credit' && (
            <Fragment>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Receipt Type'}>
                  {getFieldDecorator('receipt.type', {
                    initialValue: get(transaction, 'receipt.type'),
                    rules: [{ required: true, message: 'Please Select a Receipt Type!' }],
                  })(<ReceiptType placeholder={'Receipt Type'} />)}
                </Form.Item>
              </Col>

              {isOnBehalf && (
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayout} label={'On behalf This Company'}>
                      {getFieldDecorator('onBehalfCompany._id', {
                        initialValue: get(transaction, 'onBehalfCompany._id'),
                        rules: [
                          {
                            required: true,
                            message: 'Please Select a Company!',
                          },
                        ],
                      })(<OrganisationsSelect />)}
                    </Form.Item>
                  </Col>
                </Row>
              )}

              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Remittance Currency'}>
                  {getFieldDecorator('remittance.currency', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'remittance.currency'),
                  })(<Currency />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Remittance Amount'}>
                  {getFieldDecorator('remittance.amount', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'remittance.amount'),
                  })(<InputNumber style={{ width: '100%' }} placeholder={'Remittance Amount'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Bank Charges'}>
                  {getFieldDecorator('remittance.charges', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'remittance.charges'),
                  })(<InputNumber style={{ width: '100%' }} placeholder={'Bank Charges'} />)}
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item {...formItemLayout} label={'TT Ref'}>
                  {getFieldDecorator('remittance.ttRef', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'remittance.ttRef'),
                  })(<Input placeholder={'TT Ref'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'Clearing No'}>
                  {getFieldDecorator('remittance.clearingNo', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'remittance.clearingNo'),
                  })(<Input placeholder={'Clearing No'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayout} label={'By Order of'}>
                  {getFieldDecorator('remittance.order', {
                    normalize: normalizeNull,
                    initialValue: get(transaction, 'remittance.order'),
                  })(<Input placeholder={'By Order of'} />)}
                </Form.Item>
              </Col>
            </Fragment>
          )}
          <Col span={12}>
            <Form.Item {...formItemLayout} label="Don't Include in Reports">
              {getFieldDecorator('isNonPayAndLoss', {
                initialValue: get(transaction, 'isNonPayAndLoss'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

ReceiptForm.propTypes = {}
ReceiptForm.defaultProps = { transaction: {}, type: 'new' }

export default compose(Form.create(), withLoadingSection)(ReceiptForm)
